import type { FaireProductEntity } from "../../entity_types/product";

export const p_5eapf0pb6u: FaireProductEntity = {
  token: "p_5eapf0pb6u",
  type: "product",
  name: "The Lucinda Dress | Sleeveless Maxi Dress with Pockets",
  brandToken: "b_8dsucv84",
  brandName: "MOD REF",
  imageUrl:
    "https://cdn.faire.com/fastly/ae0a1ac5e2c25cba5a0cd4c3c14a3cd60748a5c6d0b16ac603dfd270f1726f29.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e610c8a679a89800701ebcb639ce4830c05d72b3a17bf5ce29f1b7554027b41b.jpeg",
    "https://cdn.faire.com/fastly/6988213a8ee8e1ee9663327a26b88138088677823e1bc8969a1a59404c874822.jpeg",
    "https://cdn.faire.com/fastly/515c1a1391802bca8250dfa1647b253fcc31f9ef693797e2bc2c5c1cfa376e3d.jpeg",
    "https://cdn.faire.com/fastly/533d3335cdbaab1c03423b1033604ba1bd246b2405aa01316a2cb52c75b990b2.jpeg",
    "https://cdn.faire.com/fastly/fcc3a21d1de823d605e91da724dbdf665c8708be6c9e690f8fb3ab982a77ed64.jpeg",
    "https://cdn.faire.com/fastly/960aa36d9395587d633d1697694b2eadc6b419eedb74508f59b4969c02cd67c4.jpeg",
    "https://cdn.faire.com/fastly/d147b2919384f343c734695c26de921b7b5e5908222c834097cf5958c8ff3062.jpeg",
    "https://cdn.faire.com/fastly/22bef69d4a4e28a66129af659e083fd6881b1dce3bbaf5d4af6cf276305192b5.jpeg",
    "https://cdn.faire.com/fastly/9ecd51945668a12b6f69168914b06e6d75c9c3d4a8e84f4354e2bdc9166194d4.jpeg",
    "https://cdn.faire.com/fastly/ccfc7138c20318ed9964a438b4c339f441f2ad66fbc73130a677f4546f76bdb2.jpeg",
    "https://cdn.faire.com/fastly/c340d66c4407e27036c5279a3b032c5f8e59f30c9213b414a4e01e89f61832e1.jpeg",
    "https://cdn.faire.com/fastly/638f2f6ea985a56420ed61aa993d28e421e4ad3f11a95ea2cba1f30f734121f4.jpeg",
    "https://cdn.faire.com/fastly/fda6ebb9a736e5feccb0ea76601cab4a42a4599a397f7417da9c14fe4cbb95a4.jpeg",
    "https://cdn.faire.com/fastly/cf44c6767128e60bc80b304f26f8da139543aca0b8a514d1b91cc9f3185a667d.jpeg",
    "https://cdn.faire.com/fastly/2692ad24f92b7ecddcaa9bdcfd39dda6e2510ab6d46d99ff95af53b4194af96c.jpeg",
    "https://cdn.faire.com/fastly/e1db7e4e91ae37f5ed8ad6fe93bfc55662b8294c195496391fdd0fca1c219a73.jpeg",
    "https://cdn.faire.com/fastly/450e95441151259a98d7d2e81bcf32dedbe3505e196ccf1794f89fef51486cf9.jpeg",
    "https://cdn.faire.com/fastly/92475238f54772d1a6b551fb3864e316ed716e83c626f6adc64d6d6c93a6b7fb.jpeg",
    "https://cdn.faire.com/fastly/07355562dc50503ef83054698333088a0b3bb3ba806fded28110182f633af95e.jpeg",
    "https://cdn.faire.com/fastly/6fbe27c3847e40a2e4227d7f88a485278e1777719bad718f9499d0de12c257d2.webp",
    "https://cdn.faire.com/fastly/fbf123d15d5bf845aedb03eec47ba1609620c7d5080a1f396a405bf4044b8a85.jpeg",
    "https://cdn.faire.com/fastly/fd8ff8bc28066da9602f05c00db9db862e9b545d1e2c25269d8f2f7ea5b90c37.jpeg",
    "https://cdn.faire.com/fastly/178d0507b40b47ad1845ad578db5b5a66482a704c9b78d1af4933aa4c3ead0c3.jpeg",
    "https://cdn.faire.com/fastly/12f38fc03a7d87e3cfe06db07521413073f2f6efed33e99a2e22105f3ada7e12.jpeg",
    "https://cdn.faire.com/fastly/850b0c11579da5399c8832a2a48e409f278d4bd963d703f757028e52f2fb5d41.jpeg",
    "https://cdn.faire.com/fastly/1088de3ed2f308cb68aa781f350fc8dba312bc01b5d7265ad920a0a9a83b7f7f.jpeg",
  ],
  priceDollars: 198,
  description:
    "The Lucinda Dress is a maxi-length dress with a knit square neckline top and a woven full skirt. The different fabrics create visual interest in this classic silhouette. This style also includes hidden side pockets making it the ideal option for on-the-go styling.",
  tags: [],
  msrpDollars: 396,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:54.374Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
